import React from "react";
import styled from "styled-components";
import {get} from "lodash";
import {useIsMobile, useStore} from "modules/hooks";
import {getGZLogo} from "modules/utils";
import {LOCALE} from "modules/constants";
import {QuestionWrapper} from "components/Questions/common";
import {AuthButtons} from "components/Buttons/AuthButtons";

const Wrapper = styled(QuestionWrapper)`
	position: relative;
	display: flex;
	background: #010101;
`;

const Container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	flex-grow: 1;
	padding: calc(8vh + 160px) 7% calc(4vh + 60px);
	color: #ffffff;

	@media (max-width: 840px) {
		padding: calc(8vh + 150px) 32px calc(4vh + 60px);
	}
`;

const Logo = styled.img`
	max-width: 844px;
	width: 70%;
	margin-bottom: 40px;

	@media (max-width: 840px) {
		width: 140px;

		&.fr {
			width: 160px;
			margin-bottom: 10px;
		}
	}
`;

const Text = styled.div`
	font-weight: 700;
	font-size: 24px;
	line-height: 34px;
	text-align: center;
	margin-bottom: 28px;
`;

export const GamezoneCTA: React.FC = () => {
	const {I18n, UISquadList} = useStore();
	const {isMobile} = useIsMobile("(max-width: 840px)");
	const logo = getGZLogo(isMobile);
	const topSquad = UISquadList.topSquad;
	const name = get(topSquad?.fullName, LOCALE, "");

	return (
		<Wrapper>
			<Container>
				<Logo src={logo} className={LOCALE} alt="CFL" />
				<Text>{I18n.t("gz_cta.text", {X: name})}</Text>

				<AuthButtons />
			</Container>
		</Wrapper>
	);
};
